import React, { useState, useRef, useEffect } from 'react';
import ContentEditable from 'react-contenteditable';
import { compress, decompress } from 'shrink-string';
import QRCode from 'qrcode';
import './index.css';

function App() {
  const editableRef = useRef();
  const [editableText, setEditableText] = useState('');
  const [viewMode, setViewMode] = useState(true);
  const root = window.location.toString().split('/')[0];

  const focusEditor = () => {
    editableRef.current.setAttribute('tabindex', 1);
    editableRef.current.focus();
  };

  useEffect(() => {
    async function decodeURL() {
      const content = await decompress(window.location.hash.substring(2));
      setEditableText(content);
      if (content.length === 0) {
        setViewMode(false);
      }
    }
    decodeURL();
    focusEditor();
  }, []);

  useEffect(() => {
    async function encodeURL() {
      const compressed = await compress(editableText);
      window.location = `${root}#/${compressed}`;
    }
    encodeURL();
    // console.log('length: ' + window.location.hash.length);
    // console.log(Buffer.byteLength(window.location.hash.substring(2), 'utf-8'));
  }, [editableText, root]);

  return (
    <div className="app">
      <div className="header">
        {viewMode && (
          <button
            onClick={() => {
              setViewMode(!viewMode);
              focusEditor();
            }}
          >
            Edit
          </button>
        )}
        <button
          onClick={() => {
            QRCode.toDataURL(window.location.href)
              .then((url) => {
                const win = window.open();
                win.document.write(
                  `<iframe src="${url}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`
                );
              })
              .catch((err) => {
                console.error(err);
              });
          }}
        >
          QR Code
        </button>
      </div>
      <ContentEditable
        className="editor"
        innerRef={editableRef}
        disabled={viewMode}
        html={editableText}
        placeholder={'Edit me'}
        onChange={(event) => {
          const html = event.target.value;
          setEditableText(html);
        }}
      />
    </div>
  );
}

export default App;
